Loalb-tab
<script>
import Layout from "../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { hospitalComputed, hospitalMethods } from "@/state/helpers";
import Locomo7 from "../../components/widgets/locomo-7.vue";
import HipScore from "../../components/widgets/hip-score.vue";
import Locomo25 from "../../components/widgets/locomo25.vue";
import Rokomo from "../../components/widgets/rokomo.vue";
import RehabHistories from "../../components/widgets/rehab-histories.vue";
import Medical from "../../components/widgets/medical.vue";
import { filter } from "../../helpers/Vue-Filter";
import Loader from "../../components/widgets/loader.vue";
//PDF export
import pdfLocomo7 from "../pdf/locomo7.vue";
import pdfLocomo25 from "../pdf/locomo25.vue";
import pdfRokomo from "../pdf/rokomo.vue";
import pdfHipscore from "../pdf/hipscore.vue";
import pdfRehab from "../pdf/rehab.vue";
import pdfMedical from "../pdf/medical.vue";
import { mixin } from "../../helpers/Vue-Mixin";
import api from "@/api";
import StepCountGraphList from "../../components/widgets/stepCountGraphList.vue";
import RangerOfMotion from "../../components/widgets/rangerOfMotion.vue";
import { getProfile } from "../../helpers/Auth";
import MetChart from "../../components/widgets/metChart.vue";
import EditRokomoTest from "@/components/widgets/modal/edit-rokomo-test.vue";
import { startTiming, stopTiming } from "../../helpers/Timer";
import moment from 'moment';
import Fjs12 from "../../components/widgets/fjs12.vue";
import FJS12iveMeter from "../../components/widgets/five-meter.vue";
import FiveMeter from "../../components/widgets/five-meter.vue";

export default {
  filters: {
    ...filter,
  },

  mixins: [mixin],

  page: {
    page: {
      title: "患者一覧",
      meta: [{ name: "description", content: appConfig.description }],
    }
  },

  components: {
    Layout,
    PageHeader,
    Locomo7,
    HipScore,
    Locomo25,
    Fjs12,
    Rokomo,
    RehabHistories,
    Medical,
    Loader,
    VueHtml2pdf: () => import(/* webpackPrefetch: true */ "vue-html2pdf"),
    pdfLocomo7,
    pdfLocomo25,
    pdfHipscore,
    pdfRehab,
    pdfMedical,
    pdfRokomo,
    StepCountGraphList,
    RangerOfMotion,
    MetChart,
    EditRokomoTest,
    FiveMeter
  },
  data() {
    return {
      title: "Advanced Table",
      items: [
        {
          text: "患者一覧",
          href: "/#/hospital/patients",
        },
        {
          text: " 詳細データ",
          active: true,
        },
      ],
      current_page: 1,
      flavours: [],
      selected: [],
      allSelected: false,
      indeterminate: false,
      role: getProfile().role.name,
      type: getProfile().facility?.type,
      facility_id: getProfile().facility?.id,
      time_out_facility: '',
      loaderLocomo7: false,
      loaderLocomo25: false,
      loaderHipscore: false,
      loaderMedical: false,
      loaderInfomation: false,
      loaderRokomoTest: false,
      loaderFiveMeter: false,
      loaderRehabHistory: false,
      openedTestModal: false,
      loaderFjs12: false,

      optionsPDF: {},

      dataPDFLocomo7: [],
      dataPDFLocomo25: [],
      dataPDFHipscore: [],
      dataPDFMedical: [],
      dataPDFRokomo: [],
      dataPDFRehab: [],
      html2PdfRehab: [],
      dataPDFFjs12: [],

      timerProgress: 15000,
      progress: false,

      dataWrapLoco7: [],
      dataWrapLoco25: [],
      dataWrapHipScore: [],
      dataWrapMedical: [],
      dataWrapRokomo: {},
      dataWrapFiveMeter: [],
      dataWrapRehab: {},
      editRokomo: {},
      dataWrapFjs12: {},
      dataQuestionsFjs12: {},
      lastLoadedTime: null,

      isShowProfile: true,
    };
  },

  computed: {
    ...hospitalComputed,
    theme() {
      return this.$store.state.theme;
    },
    rows() {
      return this.tableData.length;
    },
  },

  async created() {
    const formattedDate = moment().format('YYYY/MM/DD HH:mm:ss');
    localStorage.setItem('lastLoadedTime', formattedDate);
    this.lastLoadedTime = localStorage.getItem('lastLoadedTime');

    const startAt = startTiming(() => {
      this.loaderLocomo7 = true;
      this.loaderInfomation = true;
    });
    try {
      await this.getPatientById({id: this.$route.params.id, facility_id: this.facility_id});
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      this.dataWrapLoco7 = JSON.parse(JSON.stringify(this.gHistories));
      stopTiming(startAt, 1000, () => {
        this.loaderLocomo7 = false;
        this.loaderInfomation = false;
      });
    }
    this.$store.dispatch('saveTheme', this.role === 'admin' ? 'admin' : this.type === 2 ? 'plus' : 'normal');
  },

  mounted() {
  },
  methods: {
    ...hospitalMethods,

    isLastFacilityTimeout(joinFacility) {
      if (joinFacility == null) return null;
      const facilities = JSON.parse(joinFacility);
      if (joinFacility.length === 0) return null;
      const lastFacility = facilities[facilities.length - 1];

      return lastFacility.time_out;
    },

    handlerExportExcel(user_id, uuid) {
      this.loaderInfomation = true;
      try {
        const formattedDate = moment().format('YYYYMMDD');
        api.exportDataHistory(user_id, uuid, this.isLastFacilityTimeout(this.gPatientById?.join_facility),this.type == 2 ? 'plus' : 'normal',
        `詳細データ_${this.gPatientById.mobile}_${this.gPatientById.patient_id}_${formattedDate}`);
      } catch (error) {
        console.error("error:", error);
      } finally {
        this.loaderInfomation = false;
      }
    },

    hasStartedGeneration() {
    },

    hasGenerated(e) {
      // eslint-disable-next-line no-console
      console.log(e);
    },

    generateReport() {
      try {
        this.$refs.html2Pdf.generatePdf();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    onProgress(event) {
      if (!this.progress) {
        this.progress = true;
        this.progressBar(this.timerProgress);
      }
      if (event == 100) {
        this.progress = false;
        const loading = document.getElementsByClassName("swal2-confirm");
        if (loading.length > 0) {
          loading[0].click();
        }
      }
    },

    generatePDF() {
      this.$refs.html2PdfLocomo25.generatePdf();
    },

    getData(uuids) {
      const data = [];
      for (const item of this.gHistories) {
        if (uuids.includes(item.uuid)) {
          data.push(item);
        }
      }

      return data;
    },

    exportPDFHipscores() {
      this.dataPDFHipscore = JSON.parse(JSON.stringify(this.gHistories));
      this.$refs.html2PdfHipscore.generatePdf();
    },

    exportPDFHipscore(arrList = []) {
      if (arrList && arrList.length > 0) {
        this.dataPDFHipscore = this.getData(arrList);
        this.$refs.html2PdfHipscore.generatePdf();
      }
    },

    exportPDFMedicals(value) {
      this.dataPDFMedical = JSON.parse(JSON.stringify(value));
      this.$refs.html2PdfMedical.generatePdf();
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },

    exportPDFMedical(arrList = []) {
      if (arrList && arrList.length > 0) {
        const data = [];
        arrList.forEach((medical) => {
          const index = this.gMedicals.findIndex(function (item) {
            return item.uuid == medical.uuid;
          });
          if (index >= 0) {
            data.push(this.gMedicals[index]);
          }
        });

        this.dataPDFMedical = data;
        this.$refs.html2PdfMedical.generatePdf();
      }
    },

    async exportPDFLocomos7() {
      this.dataPDFLocomo7 = [];
      this.dataPDFLocomo7 = JSON.parse(JSON.stringify(this.gHistories));

      await this.$refs.html2Pdf.generatePdf();
    },

    exportPDFLocomo7(arrList = []) {
      this.dataPDFLocomo7 = [];
      if (arrList && arrList.length > 0) {
        this.dataPDFLocomo7 = this.getData(arrList);
        this.$refs.html2Pdf.generatePdf();
      }
    },

    async exportPDFLocomos25() {
      this.dataPDFLocomo25 = JSON.parse(JSON.stringify(this.gHistories));
      await this.$refs.html2PdfLocomo25.generatePdf();
    },

    exportPDFLocomo25(arrList = []) {
      if (arrList && arrList.length > 0) {
        this.dataPDFLocomo25 = this.getData(arrList);
        this.$refs.html2PdfLocomo25.generatePdf();
      }
    },

    async exportPDFRokomo(ids) {
      const fetchData = async (items) => {
        for (let i = 0; i < items.length; i++) {
          if (items[i].fim_survey_id) {
            const response = await api.getFimAnswersById(items[i].fim_survey_id);
            this.$set(this.dataPDFRokomo[i], 'dataFim', response.data);
          } else {
            this.$set(this.dataPDFRokomo[i], 'dataFim', '');
          }

          if (items[i].bi_survey_id) {
            const responseBi = await api.getBiAnswersById(items[i].bi_survey_id);
            this.$set(this.dataPDFRokomo[i], 'dataBi', responseBi.data);
          } else {
            this.$set(this.dataPDFRokomo[i], 'dataBi', '');
          }
        }
      };

      this.dataPDFRokomo = ids ? this.dataWrapRokomo.data.filter(i => ids.includes(i.id)) : this.dataWrapRokomo.data;
      await fetchData(this.dataPDFRokomo);
      await this.$refs.html2PdfRokomo.generatePdf();
    },

    async exportPDFRehabHistories(indexes) {
      let items = [];
      for (const index of indexes) {
        const history = this.dataWrapRehab.data[index];

        if (history) {
          for (const item of history.data) {
            item.rehab_video_suggestion_title = history.rehab_video_suggestion_title;

            items.push(item);
          }
        }
      }

      this.dataPDFRehab = items;
      await this.$refs.html2PdfRehab.generatePdf();
    },


    async loadMoreLoco7() {
      try {
        const res = await this.fetchHistories({
          survey_type: 1,
          uuid: this.$route.params.id,
          page: this.current_page + 1,
          time_out_facility: this.isLastFacilityTimeout(this.gPatientById?.join_facility),
        })

        if (res.status === 200) {
          this.dataWrapLoco7 = this.dataWrapLoco7.concat(res.data.data);
          this.current_page++;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    async reloadLocomo7() {
      const startAt = startTiming(() => this.loaderLocomo7 = true);
      try {
        const res = await this.fetchLocomoHistories({
          role: this.role,
          survey_type: 1,
          uuid: this.$route.params.id,
          time_out_facility: this.isLastFacilityTimeout(this.gPatientById?.join_facility),
        })

        if (res.status === 200) {
          this.dataWrapLoco7 = res.data.data;
          this.current_page = 1;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      } finally {
        stopTiming(startAt, 1000, () => this.loaderLocomo7 = false);
      }
    },

    async reloadLocomo25() {
      const startAt = startTiming(() => this.loaderLocomo25 = true);
      try {
        const res = await this.fetchLocomoHistories({
          role: this.role,
          survey_type: 2,
          uuid: this.$route.params.id,
          time_out_facility: this.isLastFacilityTimeout(this.gPatientById?.join_facility),
        })

        if (res.status == 200) {
          this.dataWrapLoco25 = res.data.data;
          this.current_page = 1;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      } finally {
        stopTiming(startAt, 1000, () => this.loaderLocomo25 = false);
      }
    },

    async reloadFjs12() {
      try {
        this.loaderFjs12 = true;
        const res = await api.listFjs12Tests(this.gPatientById.id, this.isLastFacilityTimeout(this.gPatientById?.join_facility))

        if (res.status === 200) {
          this.dataWrapFjs12 = res?.data;
          this.current_page = 1;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        window.toastr.error(error.response.status);
      } finally {
        setTimeout(
          function () {
            this.loaderFjs12 = false;
          }.bind(this),
          1000
        );
      }
    },

    async loadMoreLoco25() {
      try {
        const res = await this.fetchHistories({
          survey_type: 2,
          uuid: this.$route.params.id,
          page: this.current_page + 1,
          time_out_facility: this.isLastFacilityTimeout(this.gPatientById?.join_facility),
        })

        if (res.status == 200) {
          this.current_page++;
          if (this.dataWrapLoco25.length < res.data.meta.total) {
            this.dataWrapLoco25 = this.dataWrapLoco25.concat(res.data.data);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    async loadMoreRokomo() {
      try {
        const res = await api.listRokomoTests(this.$route.params.id, this.isLastFacilityTimeout(this.gPatientById?.join_facility), this.current_page + 1);
        if (res.status === 200) {
          this.current_page++;
          if (this.dataWrapRokomo.data.length < res.data.meta.total) {
            this.dataWrapRokomo.data = this.dataWrapRokomo.data.concat(res.data.data);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        window.toastr.error(error.response.status);
      }
    },

    async loadMoreRehabHistories() {
      try {
        const res = await api.paginateReHabHistories(this.gPatientById.id, this.isLastFacilityTimeout(this.gPatientById?.join_facility), this.current_page + 1);
        if (res.status === 200) {
          this.current_page++;
          if (this.dataWrapRehab.data.length < res.data.meta.total) {
            this.dataWrapRehab.data = this.dataWrapRehab.data.concat(res.data.data);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        window.toastr.error(error.response.status);
      }
    },

    async loadMoreHipScore() {
      try {
        const res = await this.fetchHistories({
          survey_type: 3,
          uuid: this.$route.params.id,
          page: this.current_page + 1,
          time_out_facility: this.isLastFacilityTimeout(this.gPatientById?.join_facility),
        })

        if (res.status === 200) {
          this.current_page++;
          if (this.dataWrapHipScore.length < res.data.meta.total) {
            this.dataWrapHipScore = this.dataWrapHipScore.concat(res.data.data);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    async loadMoreMedical() {
      try {
        const me = getProfile();
        const res = await this.getMedicalHistory({
          role: me.role.name,
          uuid: this.gPatientById.medical_uuid,
          page: this.current_page,
          time_out_facility: this.isLastFacilityTimeout(this.gPatientById?.join_facility),
        })

        if (res.status == 200) {
          if (this.dataWrapMedical.length < res.data.meta.total) {
            this.dataWrapMedical = this.dataWrapMedical.concat(res.data.data);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    async loadMoreFjs12() {
      try {
        const res = await api.listFjs12Tests(this.gPatientById.id, this.isLastFacilityTimeout(this.gPatientById?.join_facility), this.current_page + 1);
        if (res.status === 200) {
          this.current_page++;
          if (this.dataWrapFjs12.data.length < res.data.meta.total) {
            this.dataWrapFjs12.data = this.dataWrapFjs12.data.concat(res.data.data);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        window.toastr.error(error.response.status);
      }
    },

    async handleEditRokomo(data) {
      this.editRokomo = data;
      this.openedTestModal = true;
    },

    async clickTabs(value) {
      let startAt;
      switch (value) {
        case "LCM7":
          startAt = startTiming(() => this.loaderLocomo7 = true);
          try {
            const res = await this.fetchHistories({
              survey_type: 1,
              uuid: this.$route.params.id,
              time_out_facility: this.isLastFacilityTimeout(this.gPatientById?.join_facility),
            });
            if (res.status === 200) {
              this.dataWrapLoco7 = JSON.parse(JSON.stringify(this.gHistories));
              this.current_page = 1;
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            window.toastr.error(error.response.status);
          } finally {
            stopTiming(startAt, 2000, () => this.loaderLocomo7 = false);
          }
          break;
        case "LCM25":
          startAt = startTiming(() => this.loaderLocomo25 = true);
          try {
            const res = await this.fetchHistories({
              survey_type: 2,
              uuid: this.$route.params.id,
              time_out_facility: this.isLastFacilityTimeout(this.gPatientById?.join_facility),
            })

            if (res.status == 200) {
              this.dataWrapLoco25 = JSON.parse(JSON.stringify(this.gHistories));
              this.current_page = 1;
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            window.toastr.error(error.response.status);
          } finally {
            stopTiming(startAt, 2000, () => this.loaderLocomo25 = false);
          }
          break;
        case "FJS12":
          try {
            this.loaderFjs12 = true;
            const res = await api.listFjs12Tests(this.gPatientById.id, this.isLastFacilityTimeout(this.gPatientById?.join_facility))

            if (res.status === 200) {
              this.dataWrapFjs12 = res?.data
              this.current_page = 1;
            }
            const dataRes = await api.listFjs12Questions()
            if (dataRes.status === 200) {
              this.dataQuestionsFjs12 = dataRes?.data
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            window.toastr.error(error.response.status);
          } finally {
            setTimeout(
              function () {
                this.loaderFjs12 = false;
              }.bind(this),
              500
            );
          }
          break;
        case "HIPSCORE":
          startAt = startTiming(() => this.loaderHipscore = true);
          try {
            const response = await this.fetchHistories({
              survey_type: 3,
              uuid: this.$route.params.id,
              time_out_facility: this.isLastFacilityTimeout(this.gPatientById?.join_facility),
            });
            if (response.status == 200) {
              this.dataWrapHipScore = JSON.parse(JSON.stringify(this.gHistories));
              this.current_page = 1;
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            window.toastr.error(error.response.status);
          } finally {
            stopTiming(startAt, 2000, () => this.loaderHipscore = false);
          }
          break;
        case "MEDICAL":
          startAt = startTiming(() => this.loaderMedical = true);
          try {
          } catch (error) {
            window.toastr.error(error.response.status);
            // eslint-disable-next-line no-console
            console.log(error);
          } finally {
            stopTiming(startAt, 2000, () => this.loaderMedical = false);
          }
          break;
        case "ROKOMO":
          startAt = startTiming(() => this.loaderRokomoTest = true);
          try {
            const res = await api.listRokomoTests(this.$route.params.id, this.isLastFacilityTimeout(this.gPatientById?.join_facility), 1);
            this.dataWrapRokomo = res.data;
            this.current_page = 1;
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            window.toastr.error(error.response.status);
          } finally {
            stopTiming(startAt, 2000, () => this.loaderRokomoTest = false);
          }
        case "FIVEMETER":
          startAt = startTiming(() => this.loaderFiveMeter = true);
          try {
            const res = await api.listFiveMeter(this.$route.params.id, this.isLastFacilityTimeout(this.gPatientById?.join_facility), 1);
            this.dataWrapFiveMeter = res.data;
            this.current_page = 1;
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            window.toastr.error(error.response.status);
          } finally {
            stopTiming(startAt, 2000, () => this.loaderFiveMeter = false);
          }
        case "REHAB":
          startAt = startTiming(() => this.loaderRehabHistory = true);
          try {
            const res = await api.paginateReHabHistories(this.gPatientById.id, this.isLastFacilityTimeout(this.gPatientById?.join_facility));
            this.dataWrapRehab = res.data;
            this.current_page = 1;
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            window.toastr.error(error.response.status);
          } finally {
            stopTiming(startAt, 2000, () => this.loaderRehabHistory = false);
          }
      }
    },

    closeTestModal() {
      this.openedTestModal = false;
    },

    async reloadRokomoTest() {
      const startAt = startTiming(() => this.loaderRokomoTest = true);
      try {
        const res = await api.listRokomoTests(this.$route.params.id, this.isLastFacilityTimeout(this.gPatientById?.join_facility), 1);

        if (res.status === 200) {
          this.dataWrapRokomo = res.data;
          this.current_page = 1;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        window.toastr.error(error.response.status);
      } finally {
        stopTiming(startAt, 2000, () => this.loaderRokomoTest = false);
      }
    },
    reloadPage() {
      window.location.reload();
    },
    toggleProfile() {
      this.isShowProfile = !this.isShowProfile;
    },
  },

  watch: {
    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.flavours.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<template>
  <div :id="theme">
    <EditRokomoTest v-if="openedTestModal" :rokomo="editRokomo" :user="gPatientById" @eReloadRokomo="reloadRokomoTest"
      @close="closeTestModal" :theme="type === 2 ? 'plus' : 'normal'"></EditRokomoTest>
    <Layout>
      <div class="position-relative d-flex mb-2 mb-lg-5 mb-xl-3 mt-xl-2">
        <div class="col-12 mt-1 mt-lg-n1 mt-xl-1">
          <PageHeader :items="items" :theme="theme" fontSize="20px" fontWeight="700 !important" />
        </div>
        <div class="d-flex reload-button" style="margin-left: 14rem">
          <button @click="reloadPage" class="custom-button">
            <img src="@/assets/images/icon/icon-reload.svg" alt="" style="width: 20px; height: 20px;" />
            更新
          </button>
          <div class="ml-1">
            <p style="margin: 0; padding-left: 10px; font-size: 14px;">最終更新日時:</p>
            <p style="margin: 0; padding-left: 10px; font-size: 14px; margin-top: -5px;">{{ lastLoadedTime }}</p>
          </div>
        </div>
        <div class="position-absolute mt-4 mt-md-n2 mt-lg-n3 mt-xl-n4 d-flex px-4 px-md-3" style="right: 0rem;">
          <button @click="toggleProfile()" class="btn btn-outline-lyg w-100 btn-secondary px-2 status-label d-flex"
            style="border-radius: 4px !important; align-items: center; justify-content: center;">
            <img :src="isShowProfile ? require(`@/assets/images/icon/caret-up-fill${theme === 'normal' ? '-nor' : ''}.svg`) : require(`@/assets/images/icon/caret-down-fill${theme === 'normal' ? '-nor' : ''}.svg`)" alt="" style="width: 20px; height: 20px;" />
            プロファイル
          </button>
          <button class="w-lg badge rounded-pill status-label m-0 btn-lyg"
            style="border: none; margin-left: 10px !important;"
            @click="handlerExportExcel(gPatientById.id, gPatientById.uuid)">
            全項目Excel出力
          </button>
        </div>
      </div>
      <div class="card" v-if="isShowProfile">
        <Loader :theme="type === 2 ? 'plus' : 'normal'" :loading="loaderInfomation">
          <div class="card-body pt-4 pb-3">
            <div class="d-flex justify-content-between">
              <h5 class="text-table">
                {{ $t("menuitems.hospital.memberProfile") }}
              </h5>
              
            </div>
            <hr class="mb-1" />
            <div class="row">
              <div class="col-md-3">
                <div class="mt-3">
                  <label class="text-labelInfo">携帯番号</label>
                  <h6 class="text-table">
                    {{ gPatientById ? gPatientById.mobile : "" }}
                  </h6>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mt-3">
                  <label class="text-labelInfo">患者ID</label>
                  <h6 class="text-table">
                    {{ gPatientById ? gPatientById.patient_id : "" }}
                  </h6>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mt-3">
                  <label class="text-labelInfo">
                    {{ $t("menuitems.hospital.sex") }}
                  </label>
                  <h6 class="text-table">
                    {{ gPatientById.information && gPatientById.information.sex === 0 ? "女性" : gPatientById.information
                      && gPatientById.information.sex === 1 ? "男性" : "無回答" }}
                  </h6>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mt-3">
                  <label class="text-labelInfo"> 生年月日 </label>
                  <h6 class="text-table">
                    <b>{{ gPatientById.information ? gPatientById.information.birthday : "" }}</b>
                  </h6>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="mt-3">
                  <label class="text-labelInfo"> 名前 </label>
                  <h6 class="text-table">
                    <b>{{ gPatientById.information ? gPatientById.information.fullname : "" }}</b>
                  </h6>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mt-3">
                  <label class="text-labelInfo"> 年齢 </label>
                  <h6 class="text-table">
                    <b>{{ gPatientById.information ? gPatientById.information.age : "" }}</b>
                  </h6>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mt-3">
                  <label class="text-labelInfo"> 都道府県 </label>
                  <h6 class="text-table">
                    <b>{{ gPatientById.information ? gPatientById.information.city : "" }}</b>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </Loader>
      </div>
      <div class="row">
        <div class="col-lg">
          <div class="card bg-transparent">
            <div>
              <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-lgy"
                active-tab-class="font-weight-bold text-muted p-md-2 pb-md-1" content-class="text-muted bg-white">
                <b-tab active>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{ $t("menuitems.hospital.judgmentResult") }}</span>
                  </template>

                  <div>
                    <b-tab lazy :title="$t('menuitems.hospital.medicalExamination')" active
                      @click="clickTabs('MEDICAL')">
                      <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true"
                        :preview-modal="false" :paginate-elements-by-height="1200"
                        :html-to-pdf-options="{ margin: 10, filename: `身体状態_${gPatientById ? gPatientById.patient_id : ''}` }"
                        :pdf-quality="2" :manual-pagination="true" pdf-format="a4" pdf-orientation="portrait"
                        pdf-content-width="100%" @progress="onProgress($event)"
                        @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)"
                        ref="html2PdfMedical">
                        <section slot="pdf-content">
                          <template>
                            <pdfMedical :infoPDF="gPatientById" :dataPdf="dataPDFMedical" />
                          </template>
                        </section>
                      </VueHtml2pdf>
                      <Loader :theme="theme" :loading="loaderMedical">
                        <Medical @exportPDFMedicals="exportPDFMedicals" @exportPDFMedical="exportPDFMedical" @reloadMedical="clickTabs('MEDICAL')"
                          @loadMoreMedical="loadMoreMedical()" :time_out_facility="this.isLastFacilityTimeout(this.gPatientById?.join_facility)" :isExpand="!isShowProfile"/>
                      </Loader>
                    </b-tab>

                    <b-tab lazy :title="$t('menuitems.hospital.loco7')" @click="clickTabs('LCM7')">
                      <Loader :theme="theme" :loading="loaderLocomo7">
                        <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true"
                          :preview-modal="false" :manual-pagination="false" :paginate-elements-by-height="1400"
                          :html-to-pdf-options="{
                            margin: 0,
                            filename: `7つのロコチェック_${gPatientById ? gPatientById.patient_id : ''}`,
                            enableLinks: false,
                            html2canvas: { scale: 1, useCORS: true },
                            jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
                          }" pdf-format="a4" pdf-orientation="portrait" pdf-content-width="100%"
                          @progress="onProgress($event)" @hasStartedGeneration="hasStartedGeneration()"
                          @hasGenerated="hasGenerated($event)" ref="html2Pdf">
                          <section slot="pdf-content">
                            <template>
                              <pdfLocomo7 :infoPDF="gPatientById" :locomo7="dataPDFLocomo7" />
                            </template>
                          </section>
                        </VueHtml2pdf>
                        <Locomo7 @pdfLocomos7="exportPDFLocomos7" @pdfLocomo7="exportPDFLocomo7"
                          @reloadLocomo7="reloadLocomo7()" @loadMoreLocomo7="loadMoreLoco7()" :locomo7="dataWrapLoco7" :userInfor="gPatientById"
                          :pagination="gPaginationHistory" :time_out_facility="this.isLastFacilityTimeout(this.gPatientById?.join_facility)" :isExpand="!isShowProfile"/>
                      </Loader>
                    </b-tab>

                    <b-tab lazy :title="$t('menuitems.hospital.loco25')" @click="clickTabs('LCM25')">
                      <Loader :theme="theme" :loading="loaderLocomo25">
                        <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true"
                          :preview-modal="false" :paginate-elements-by-height="1200" :pdf-quality="2"
                          :manual-pagination="true"
                          :html-to-pdf-options="{ margin: [15, 0, 19, 0], filename: `ロコモ25_${gPatientById ? gPatientById.patient_id : ''}` }"
                          pdf-format="a4" pdf-orientation="portrait" pdf-content-width="100%"
                          @progress="onProgress($event)" @hasStartedGeneration="hasStartedGeneration()"
                          @hasGenerated="hasGenerated($event)" ref="html2PdfLocomo25">
                          <section slot="pdf-content">
                            <template>
                              <pdfLocomo25 :infoPDF="gPatientById" :locomo25="dataPDFLocomo25" />
                            </template>
                          </section>
                        </VueHtml2pdf>
                        <Locomo25 @pdfLocomos25="exportPDFLocomos25" @pdfLocomo25="exportPDFLocomo25"
                          @loadMoreLocomo25="loadMoreLoco25()" @reloadLocomo25="reloadLocomo25()" :userInfor="gPatientById" :isExpand="!isShowProfile"
                          :locomo25="dataWrapLoco25" :pagination="gPaginationHistory" :time_out_facility="this.isLastFacilityTimeout(this.gPatientById?.join_facility)" />
                      </Loader>
                    </b-tab>

                    <b-tab lazy :title="$t('menuitems.hospital.hipscore')" @click="clickTabs('HIPSCORE')">
                      <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true"
                        :preview-modal="false" :paginate-elements-by-height="1200"
                        :html-to-pdf-options="{ margin: 10, filename: `股関節スコア_${gPatientById ? gPatientById.patient_id : ''}` }"
                        :pdf-quality="2" :manual-pagination="true" pdf-format="a4" pdf-orientation="portrait"
                        pdf-content-width="100%" @progress="onProgress($event)"
                        @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)"
                        ref="html2PdfHipscore">
                        <section slot="pdf-content">
                          <template>
                            <pdfHipscore :infoPDF="gPatientById" :hipscore="dataPDFHipscore" />
                          </template>
                        </section>
                      </VueHtml2pdf>
                      <Loader :theme="theme" :loading="loaderHipscore">
                        <HipScore @exportPDFHipcores="exportPDFHipscores" @exportPDFHipscore="exportPDFHipscore"
                          :hipscore="dataWrapHipScore" @loadMoreHipscore="loadMoreHipScore()" :userInfor="gPatientById"
                          :pagination="gPaginationHistory" :isExpand="!isShowProfile"/>
                      </Loader>
                    </b-tab>

                    <b-tab>
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="fas fa-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">可動域評価</span>
                      </template>
                      <RangerOfMotion :key="gPatientById.id" v-if="gPatientById.id" :userId="gPatientById.id" :time_out_facility="this.isLastFacilityTimeout(this.gPatientById?.join_facility)" :userInfor="gPatientById" :isExpand="!isShowProfile"/>
                    </b-tab>

                    <b-tab lazy title="股関節の違和感チェック" @click="clickTabs('FJS12')">
                      <Loader :theme="theme" :loading="loaderFjs12">
                        <Fjs12 @loadMoreFjs12="loadMoreFjs12()" :fjs12="dataWrapFjs12.data" :isExpand="!isShowProfile"
                          :dataQuestionsFjs12="dataQuestionsFjs12" @reloadFjs12="reloadFjs12()" :userInfor="gPatientById"
                          :time_out_facility="this.isLastFacilityTimeout(this.gPatientById?.join_facility)" :pagination="dataWrapFjs12.meta"/>
                      </Loader>
                    </b-tab>

                    <b-tab>
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="fas fa-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">歩数</span>
                      </template>
                      <StepCountGraphList :key="gPatientById.id" v-if="gPatientById.id" :userId="gPatientById.id" :time_out_facility="this.isLastFacilityTimeout(this.gPatientById?.join_facility)" :userInfor="gPatientById" :isExpand="!isShowProfile"/>
                    </b-tab>

                    <b-tab>
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="fas fa-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">活動量</span>
                      </template>
                      <MetChart :key="gPatientById.id" v-if="gPatientById.id" :user="gPatientById" :theme="theme" :time_out_facility="this.isLastFacilityTimeout(this.gPatientById?.join_facility)" :isExpand="!isShowProfile"/>
                    </b-tab>

                    <b-tab lazy :title="'ロコモ度テスト等'" @click="clickTabs('ROKOMO')">
                      <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true"
                        :preview-modal="false" :paginate-elements-by-height="1200" :pdf-quality="2"
                        :manual-pagination="true"
                        :html-to-pdf-options="{ margin: [15, 0, 19, 0], filename: `測定_${gPatientById ? gPatientById.patient_id : ''}` }"
                        pdf-format="a4" pdf-orientation="portrait" pdf-content-width="100%"
                        @progress="onProgress($event)" @hasStartedGeneration="hasStartedGeneration()"
                        @hasGenerated="hasGenerated($event)" ref="html2PdfRokomo">
                        <section slot="pdf-content">
                          <template>
                            <pdfRokomo :infoPDF="gPatientById" :items="dataPDFRokomo" />
                          </template>
                        </section>
                      </VueHtml2pdf>

                      <Loader :theme="theme" :loading="loaderRokomoTest">
                        <Rokomo @pdfRokomoTests="exportPDFRokomo" @loadMoreRokomo="loadMoreRokomo()" :isExpand="!isShowProfile"
                          @enableEditRokomo="handleEditRokomo" @reloadRokomo="reloadRokomoTest" :rokomoTests="dataWrapRokomo.data" :userInfor="gPatientById"
                          :pagination="dataWrapRokomo.meta" :theme="theme" :time_out_facility="this.isLastFacilityTimeout(this.gPatientById?.join_facility)"/>
                      </Loader>
                    </b-tab>

                    <b-tab lazy title="歩行分析" @click="clickTabs('FIVEMETER')"  v-if="type != 1 && theme == 'plus'">
                      <Loader :theme="theme" :loading="loaderFiveMeter">
                        <FiveMeter @loadMore="loadMoreFiveMeter()" :fiveMeter="dataWrapFiveMeter.data" :pagination="dataWrapFiveMeter.meta"
                         :time_out_facility="this.isLastFacilityTimeout(this.gPatientById?.join_facility)" 
                         :filename="`歩行分析_${gPatientById.mobile}_${gPatientById.patient_id}_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}`"/>
                      </Loader>
                    </b-tab>

                    <b-tab lazy :title="'リハビリ履歴'" @click="clickTabs('REHAB')" v-if="type != 1">
                      <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true"
                        :preview-modal="false" :paginate-elements-by-height="1200" :pdf-quality="2"
                        :manual-pagination="true"
                        :html-to-pdf-options="{ margin: [15, 0, 19, 0], filename: `リハビリ_${gPatientById ? gPatientById.patient_id : ''}` }"
                        pdf-format="a4" pdf-orientation="portrait" pdf-content-width="100%"
                        @progress="onProgress($event)" @hasStartedGeneration="hasStartedGeneration()"
                        @hasGenerated="hasGenerated($event)" ref="html2PdfRehab">
                        <section slot="pdf-content">
                          <template>
                            <pdfRehab :user="gPatientById" :items="dataPDFRehab" />
                          </template>
                        </section>
                      </VueHtml2pdf>

                      <Loader :theme="theme" :loading="loaderRehabHistory">
                        <RehabHistories @clickExport="exportPDFRehabHistories" @loadMore="loadMoreRehabHistories()" :userInfor="gPatientById"
                          :data="dataWrapRehab.data" :pagination="dataWrapRehab.meta" :isExpand="!isShowProfile"/>
                      </Loader>
                    </b-tab>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </div>
</template>

<style scoped>
#parent {
  position: relative;
  z-index: 0;
}

#child {
  width: 100%;
  height: 100%;

  position: absolute;
  top: 50%;
  left: 50%;
  margin: -20px 0 0 -25px;
  font-size: 25px;
  z-index: 1;
}

* {
  font-family: "Noto Sans JP";
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

.text-table {
  color: #404040;
  font-weight: 700;
  font-size: 16px;
}

::v-deep .footer {
  position: fixed !important;
  left: 0px;
}

.text-labelInfo {
  color: #828282;
  font-weight: 400;
  font-size: 14px;
}

.text-link {
  color: #336aff;
}

.np-btn {
  padding: 2px 8px;
  margin: 12px 8px;
  border: 1px solid #da1010;
  width: 110px;
  background: #da1010;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
}

.custom-button {
  background-color: #8fc31f;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  color: white;
  cursor: pointer;
  z-index: 99;
}

.custom-button:hover {
  background-color: #7cc31c;
}

.status-label {
  border-radius: 4px !important;
  text-align: center;
  padding: 5px;
  width: 144px;
  height: 36px;
  font-size: 14px;
  line-height: 26px;
}
</style>
